import { ConnectIntegrationModal } from 'src/redesign/pages/IntegrationsPage/components/ConnectIntegrationModal';
import { SimpleConnectionModal } from 'src/redesign/pages/IntegrationsPage/components/modals/SimpleConnectionModal';
import { AdvancedConnectedModal } from 'src/redesign/pages/IntegrationsPage/components/modals/AdvancedConnectedModal';
import { IntegrationDetailsModal } from 'src/redesign/pages/IntegrationsPage/components/modals/IntegrationDetailsModal';
import { IntegrationConfigurationModal } from 'src/redesign/pages/IntegrationsPage/components/modals/IntegrationConfigurationModal';
import { EventCancelModal } from 'src/redesign/features/EditEvent/component/EventCancelModal';
import { RemoveEventModal } from 'src/redesign/features/EditEvent/component/RemoveEventModal';

export enum CONNECTED_MODALS {
  CONNECT_INTEGRATION_MODAL = 'CONNECT_INTEGRATION_MODAL',
  SIMPLE_INTEGRATION_CONNECT_MODAL = 'SIMPLE_INTEGRATION_CONNECT_MODAL',
  ADVANCED_INTEGRATION_CONNECT_MODAL = 'ADVANCED_INTEGRATION_CONNECT_MODAL',
  INTEGRATION_DETAILS_MODAL = 'INTEGRATION_DETAILS_MODAL',
  INTEGRATION_CONFIGURATION_MODAL = 'INTEGRATION_CONFIGURATION_MODAL',
  CANCEL_EVENT_MODAL = 'CANCEL_EVENT_MODAL',
  REMOVE_EVENT_MODAL = 'REMOVE_EVENT_MODAL',
}

export const CONNECTED_MODALS_COMPONENTS = {
  [CONNECTED_MODALS.CONNECT_INTEGRATION_MODAL]: ConnectIntegrationModal,
  [CONNECTED_MODALS.SIMPLE_INTEGRATION_CONNECT_MODAL]: SimpleConnectionModal,
  [CONNECTED_MODALS.ADVANCED_INTEGRATION_CONNECT_MODAL]: AdvancedConnectedModal,
  [CONNECTED_MODALS.INTEGRATION_DETAILS_MODAL]: IntegrationDetailsModal,
  [CONNECTED_MODALS.INTEGRATION_CONFIGURATION_MODAL]: IntegrationConfigurationModal,
  [CONNECTED_MODALS.CANCEL_EVENT_MODAL]: EventCancelModal,
  [CONNECTED_MODALS.REMOVE_EVENT_MODAL]: RemoveEventModal,
};

export const FEATURE_NAME = 'modals';
